import { enMessages as enMessagesCatalog } from './messages.en'
import { itCoreMessages } from './messages.it-core'
import { itCustomerMessages } from './messages.it-customer'

const itMessages = {
  ...itCoreMessages,
  ...itCustomerMessages,
} as const

type MessageKey = keyof typeof itMessages

const enMessages: Record<MessageKey, string> = enMessagesCatalog

export type ShopMessageKey = MessageKey

export type KnownShopLocale = 'it-IT' | 'en-US'

export const shopMessages: Record<KnownShopLocale, Record<ShopMessageKey, string>> = {
  'it-IT': itMessages,
  'en-US': enMessages,
}
